/**
 * DEV-2299. Переводы блока «Старт продаж» на вкладке юнитов.
 *
 * Отдельным модулем, как propertyShowcase: правки блока не конфликтуют с общим
 * ru.ts. Текст плашки сайта (preview.badge) совпадает с vue-web-app и ssr —
 * менять его надо во всех трёх местах сразу.
 */

const ruSalesStart = {
  title: 'Старт продаж',
  onSite: 'На сайте',
  enabled: 'Включено',
  disabled: 'Выключено',
  hint: {
    off: 'Включите, если продажи ещё не открыты: на сайте появится красная плашка «Старт продаж» с датой — вместо «Продано», когда витрина пуста, или над ценами.',
    on: 'Плашка держится, пока флаг не выключат вручную: ни наступившая дата, ни появление юнитов её не снимают.',
  },
  dateLabel: 'Дата старта продаж',
  dateRequired: 'Выберите дату — без неё плашка на сайт не уйдёт',
  datePassed:
    'Дата старта прошла {date}, а плашка всё ещё на сайте. Если продажи открылись — выключите «Старт продаж».',
  turnOff: 'Выключить',
  preview: {
    label: 'Так увидят на сайте',
    badge: 'СТАРТ ПРОДАЖ {date}',
    instead: 'вместо «Продано» — витрина пуста',
    above: 'над ценами — на витрине строк: {count}',
  },
  saved: 'Старт продаж сохранён',
  cleared: 'Плашка «Старт продаж» снята',
  saveError: 'Не удалось сохранить старт продаж',
}

const enSalesStart = {
  title: 'Sales start',
  onSite: 'On the site',
  enabled: 'On',
  disabled: 'Off',
  hint: {
    off: 'Turn on while sales are not open yet: the site shows a red "Sales start" badge with the date — instead of "Sold out" when the showcase is empty, or above the prices.',
    on: 'The badge stays until someone turns it off by hand: neither the date passing nor units appearing removes it.',
  },
  dateLabel: 'Sales start date',
  dateRequired: 'Pick a date — without it the badge does not reach the site',
  datePassed:
    'The sales start date {date} has passed, but the badge is still on the site. If sales have opened, turn "Sales start" off.',
  turnOff: 'Turn off',
  preview: {
    label: 'How the site shows it',
    badge: 'SALES START {date}',
    instead: 'instead of "Sold out" — the showcase is empty',
    above: 'above the prices — showcase rows: {count}',
  },
  saved: 'Sales start saved',
  cleared: 'The "Sales start" badge is removed',
  saveError: 'Could not save the sales start',
}

const vnSalesStart = {
  title: 'Mở bán',
  onSite: 'Trên website',
  enabled: 'Bật',
  disabled: 'Tắt',
  hint: {
    off: 'Bật khi dự án chưa mở bán: website hiển thị nhãn đỏ «Mở bán» kèm ngày — thay cho «Đã bán hết» khi bảng loại căn trống, hoặc phía trên giá.',
    on: 'Nhãn giữ nguyên cho đến khi tắt thủ công: ngày đã qua hay có căn hộ mới đều không gỡ nhãn.',
  },
  dateLabel: 'Ngày mở bán',
  dateRequired: 'Chọn ngày — thiếu ngày thì nhãn không lên website',
  datePassed:
    'Ngày mở bán {date} đã qua nhưng nhãn vẫn trên website. Nếu đã mở bán, hãy tắt «Mở bán».',
  turnOff: 'Tắt',
  preview: {
    label: 'Hiển thị trên website',
    badge: 'MỞ BÁN {date}',
    instead: 'thay cho «Đã bán hết» — bảng loại căn trống',
    above: 'phía trên giá — số dòng trong bảng: {count}',
  },
  saved: 'Đã lưu ngày mở bán',
  cleared: 'Đã gỡ nhãn «Mở bán»',
  saveError: 'Không thể lưu ngày mở bán',
}

export const propertySalesStartMessages = {
  ru: { properties: { salesStart: ruSalesStart } },
  en: { properties: { salesStart: enSalesStart } },
  vn: { properties: { salesStart: vnSalesStart } },
}
